import { useLocation } from "react-router";
import { Link } from "react-router-dom";

export const NotFound = () => {
  const { pathname } = useLocation();
  return (
    <div className="notFound">
      <div>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>There is no page with the url "{pathname}", try something else.</p>
      </div>
      <Link className="authButtons" to="/">
        Home
      </Link>
    </div>
  );
};
